// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CitationByYearChart_card__sEVWD {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 22px 24px;
  background: var(--bg-2, #fff);
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}

.CitationByYearChart_head__Y8DIv {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.CitationByYearChart_title__L6ed8 {
  margin: 0;
  font-family: "Lora", "Georgia", serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.CitationByYearChart_subtitle__tfrFg {
  margin: 0;
  font-size: 12.5px;
  color: var(--grey-text, #64748b);
  line-height: 1.5;
}

.CitationByYearChart_chart-area__gm7TP {
  width: 100%;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/CitationByYearChart/CitationByYearChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 22px 24px;\n  background: var(--bg-2, #fff);\n  border-radius: 16px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n}\n\n.head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.title {\n  margin: 0;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 12.5px;\n  color: var(--grey-text, #64748b);\n  line-height: 1.5;\n}\n\n.chart-area {\n  width: 100%;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `CitationByYearChart_card__sEVWD`,
	"head": `CitationByYearChart_head__Y8DIv`,
	"title": `CitationByYearChart_title__L6ed8`,
	"subtitle": `CitationByYearChart_subtitle__tfrFg`,
	"chart-area": `CitationByYearChart_chart-area__gm7TP`
};
export default ___CSS_LOADER_EXPORT___;
